/* unplugin-vue-components disabled */import { render } from "./share-skeleton.vue?vue&type=template&id=e8090778&scoped=true"
const script = {}

import "./share-skeleton.vue?vue&type=style&index=0&id=e8090778&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8090778"],['__file',"src/pages/share-prompt/share-skeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8090778"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8090778', __exports__)) {
    api.reload('e8090778', __exports__)
  }
  
  module.hot.accept("./share-skeleton.vue?vue&type=template&id=e8090778&scoped=true", () => {
    api.rerender('e8090778', render)
  })

}


export default __exports__